/*	MARK: Ai5 Machines
	============================================
	Create model from Template
 */

import { inject } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { Machine, MachineTemplate } from '../machines/machine-schemas';
import { DataService, Request } from '../services/data-service';
import { Api } from '../services/api';

/** Constants **/
const CustomTemplates = [
	{ name: "Time series", type:"Custom", algorithm:"serie" },
	{ name: "Multivar time series", type:"Custom", algorithm:"multivar_serie" },
	{ name: "Regression analysis", type:"Custom", algorithm:"linear" },
	{ name: "Blank model", type:"Custom", algorithm:"" },
	
]
const ReadyTemplates = [
	{
		name		:"Wine quality prediction",
		type		:"Ready",
		algorithm	:"linear",
		y_label		:"quality",
		dataset		:"684910d07546c38e6872cf73-wine_quality_white.csv",
		model_name	:"linear-68eabdd6f3a8fac4ac4031cc.bson",
		features	:[ 'fixed acidity', 'volatile acidity','citric acid','residual sugar',
					  'chlorides','free sulfur dioxide', 'total sulfur dioxide', 'density',
					  'pH','sulphates','alcohol'],
		stats		:{ loss: 0.6684934, epochs: 85081, learning_rate: 0.01,learning_limit: 1e-12},
		dataset_info: { name: 'wine_quality_white.csv', size: 264426 },
	},
]


@inject(DataService, Api, Router)
export class Templates {
	/** Component methods **/
	constructor(ds, api, router){
		// Services
		this.ds		= ds;
		this.api	= api;
		this.router = router;
		// Component varibles
		this.selectedTemplate 	= null
		this.customTemplates	= CustomTemplates;
		this.readyTemplates		= ReadyTemplates;
	}

	attached(){
		// Load Remote data (machiens)
		window.setTimeout( () => { this.init() }, 300);
	}

	init(){
		// Create empty machine for user(required)

		// Get machines
		let machines 	= this.ds.app_data.machines;
		if(!machines){
			this.getUserMachines().then(response => {
				this.handleResponseUserMachines(response);
			});
		}
		else{this.machines	= machines;}
			
	}

	/** MARK: Init remote calls
		============================================
	*/
	// Get remote data (list of machines)
	getUserMachines(){
		let uid 	= this.ds.user.uid;
		let token 	= this.ds.token;
		// Create request
		let request = new Request("/api/v2/users/"+uid+"/machines/", "GET");
		request.headers["Authorization"] = "Bearer=" + token;
		// Perform remote call
		return this.api.get(request);
	}
	/** Response handlelers */
	handleResponseUserMachines(response){
		let status = response.status
		if(status === 200){
			this.machines = response.data.reverse(); // Array 
			// To Data Service
			this.ds.app_data.machines = this.machines;
		}
	}

	/** API Calls **/
	postMachine(machine){
		let request 	= new Request("/api/v2/machines/", "POST");
		let body		= { machine: machine };
		request.body	= JSON.stringify(body);
		// Make request
		return this.api.post(request);
	}

	handlePostMachine(response){
		let machine_id = response.data._id;
		// Update app machine with buffer machine
		this.bufferMachine._id = machine_id;
		this.ds.app_data.machine = this.bufferMachine;
		//this.ds.app_data.machines.push(this.bufferMachine);
		this.ds.app_data.machines = [this.bufferMachine, ...this.ds.app_data.machines];
		// Go to models data
	}
	
	
	/** Custom methods **/

	// Create empty machine
	createMachineWithTemplate(template){
		// Create machine document
		let bufferMachine 		= new Machine();
		bufferMachine.name 		= this.ds.user.username + "-model-" + Math.floor(Math.random() * 3000);
		bufferMachine.template 	= template

		bufferMachine.algorithm	= template.algorithm;
		
		
		bufferMachine.status	= (template.type === "Ready") ? "Completed" : "Pending";


		if (bufferMachine.algorithm === "serie"){ bufferMachine.stats = { window_analysis:30, lag_period:10 } }


		if (bufferMachine.algorithm === "multivar_serie"){ bufferMachine.stats = { window_analysis:30, lag_period:10 } }

		if(template.type === "Ready"){
			bufferMachine.dataset		= template.dataset;
			bufferMachine.model_name	= template.model_name;
			bufferMachine.features		= template.features;
			bufferMachine.dataset_info	= template.dataset_info;
			bufferMachine.stats			= template.stats;
			bufferMachine.y_label		= template.y_label;

			bufferMachine.template 		= { name:template.name, type:template.type, algorithm:template.algorithm };
		}
		
		bufferMachine.uid		= this.ds.user.uid;
		this.bufferMachine		= bufferMachine;
		// Send machine to server
		this.postMachine(bufferMachine).then(response => {
			this.handlePostMachine(response);
			
		})
		.finally( () => {
			let mid = this.ds.app_data.machine._id
			window.setTimeout( () => {
				this.router.navigateToRoute("models.data", { id:mid })
			}, 300);
			//this.router.navigateToRoute("models.data", { id:mid })
		});
	}
}
